import styled from 'styled-components';
import { fade, TransitionProps } from 'styles';
import { SUGGESTED_CLIP_TOOLTIP_TRANSITION_DURATION_MILLIS } from './constants';

export const Popover = styled.div<TransitionProps>`
  ${fade({
    durationMillis: SUGGESTED_CLIP_TOOLTIP_TRANSITION_DURATION_MILLIS,
  })}
`;
